export const LOCATION = 'location';
export const IS_FLEXIBLE = 'isFlexible';
